// Traductions anglaises, rangées par partie de l'interface. Clé : le texte français (voir lib/i18n.ts).
import { common } from "./common";
import { auth } from "./auth";
import { inputs } from "./inputs";
import { outputs } from "./outputs";
import { pages } from "./pages";
import { admin } from "./admin";

export const EN_PARTS = [common, auth, inputs, outputs, pages, admin];

export const EN: Record<string, string> = Object.assign({}, ...EN_PARTS);
